import React, {useEffect, useState} from "react";
import {Col, Row} from "react-bootstrap";
import {RequireAuth} from "Components/Security/RequireAuth";
import {DefaultContainer} from "Views/Shared/DefaultContainer";
import {useNavigate, useParams} from "react-router-dom";
import {Notificator} from "Services/Notificator/Notificator";
import {AdminModalityForm} from "Views/Modalities/AdminModalityForm";
import {useDispatch} from "react-redux";
import {appLoading} from "Store/loadingSlice";
import {useMutation, useQuery} from "react-query";
import {getActivitySession, getActivitySessionStock} from "Api/Query/ActivityQuery";
import {updateActivitySession, UpdateActivitySessionRequest} from "Api/Mutation/ActivitySession";

export const AdminEditModality : React.FC = () => {

    const {id} = useParams()
    const dispatch = useDispatch()

    const [activitySession, setActivitySession] = useState<any>(null)
    const [stock, setStock] = useState<any>(null)

    const activitySessionQuery = useQuery({
        queryKey: ['getAdminActivitySessionDetail', id],
        queryFn: () => getActivitySession(id ?? ''),
        onSuccess: async (response: any) => {
            const activitySession = response.data._result
            setActivitySession(activitySession)
        },
        onError: (error: any) => {
            Notificator.error('Error al obtener la sesión', 'Error')
        }
    })

    const hasPlazasDisponiblesAttr = !!activitySession?.attributes?.some((a: any) => a.id === 'PLAZAS_DISPONIBLES')

    const activitySessionStockQuery = useQuery({
        enabled: !!id && hasPlazasDisponiblesAttr,
        queryKey: ['getAdminActivitySessionStock', id],
        queryFn: () => getActivitySessionStock(id ?? ''),
        onSuccess: (response: any) => {
            setStock(response.data._result)
        },
        onError: () => {
            Notificator.error('Error al obtener el stock de la sesión', 'Error')
        }
    })

    const activitySessionUpdate = useMutation({
        mutationFn: (body: UpdateActivitySessionRequest) => updateActivitySession(id ?? '-1', body),
        onSuccess: (response: any) => {
            Notificator.success('La modalidad se ha editado correctamente.')
            // navigate(ROUTE_PATHS.ADMIN_MODALITIES_LIST)
        },
        onError: (error: any) => {
            Notificator.error('Error al actualizar la modalidad.')
        }
    })

    useEffect(() => {
        dispatch(
            appLoading({
                value: activitySessionUpdate.isLoading,
                text: 'Cargando'
            })
        )
    }, [activitySessionUpdate.isLoading])

    useEffect(() => {
        dispatch(
            appLoading({
                value: activitySessionQuery.isLoading,
                text: 'Cargando'
            })
        )
    }, [activitySessionQuery.isLoading])

    const save = (fields: any) => {
        const weekDays : string[] = []
        fields.weekDays.map(day => weekDays.push(day.id ?? day.value))

        const centerIds :string[] = []
        fields.centers?.map(center => {
            centerIds.push(center.value)
        })

        const mutationBody: UpdateActivitySessionRequest = {
            centerIds: centerIds,
            name: fields.name,
            abbreviation: fields.abbreviation,
            description: fields.description,
            price: fields.price,
            numberOfDays: fields.numberOfDays,
            start: fields.start.length === 5 ? fields.start + ':00' : fields.start,
            end: fields.end.length === 5 ? fields.end + ':00' : fields.end,
            billable: fields.billable,
            services: fields.serviceIds,
            courseLevelIds: fields.courseLevelIds,
            weekDays: weekDays,
            attributes: fields.attributes
        }
        activitySessionUpdate.mutate(mutationBody)
    }

    return (
        <RequireAuth>
            <DefaultContainer>

                <Col id={"mainRequestList"}>

                    <Row>
                        <h1 className={"pb-4"}>Detalle de Modalidad</h1>
                    </Row>

                    {activitySession && (
                        <AdminModalityForm
                            onSave={save}
                            abbreviation={activitySession.abbreviation}
                            activity={activitySession.activity}
                            activityType={activitySession.activity.type}
                            name={activitySession.name}
                            description={activitySession.description ?? ''}
                            start={activitySession.start}
                            end={activitySession.end}
                            price={activitySession.price}
                            numberOfDays={activitySession.numberOfDays}
                            billable={activitySession.billable}
                            weekDays={activitySession.days ?? []}
                            services={activitySession.services ?? []}
                            centers={activitySession.centers ?? []}
                            courseLevels={activitySession.courseLevels ?? []}
                            attributes={activitySession.attributes ?? []}
                            isEdit={true}
                            showStock={hasPlazasDisponiblesAttr}
                            stock={stock}
                        />
                    )}
                </Col>

            </DefaultContainer>
        </RequireAuth>
    )
}
